import builder from '../builder';
import Heater from '../../streamline-icons/bold/heater.svg';

export default builder('IconHeaterBold', Heater);
